const content: { [key: string]: string } = {
  pageTitle: "Provide Us Feedback",
};

export default content;
